import { render } from "./SimpleDataTable.vue?vue&type=template&id=5f7c2956&scoped=true"
import script from "./SimpleDataTable.vue?vue&type=script&lang=js"
export * from "./SimpleDataTable.vue?vue&type=script&lang=js"

import "./SimpleDataTable.vue?vue&type=style&index=0&id=5f7c2956&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f7c2956"]])

export default __exports__